import { render } from "./InstallPwa.vue?vue&type=template&id=54e6d753&scoped=true"
import script from "./InstallPwa.vue?vue&type=script&lang=js"
export * from "./InstallPwa.vue?vue&type=script&lang=js"

import "./InstallPwa.vue?vue&type=style&index=0&id=54e6d753&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-54e6d753"

export default script